export const DEFAULT_QUERY = 'default_results';
